import { UiNotificationType } from '@infuse/ui/domain';
import { useNotify } from '@infuse/ui/services';
import { i18n } from '@infuse/utils';

const notify = useNotify();

export const notifyNotFound = (timeout = 3000): void => {
  // This is being triggered when navigating to a route that doesn't exist
  // This can be triggered before translations, we wait a short time to make sure translations are loaded
  // 200ms is not noticeable to the user, but it's enough to make sure translations are loaded
  setTimeout(() => {
    notify({
      title: i18n.global.t('notifications.page_not_found'),
      message: i18n.global.t('notifications.redirecting'),
      type: UiNotificationType.INFO,
      group: 'notify-top',
      timeout
    });
  }, 200);
};

export const notifyNotAllowed = (timeout = 3000): void => {
  // This is being triggered when navigating to a page that the user doesn't have access to
  // This can be triggered before translations, we wait a short time to make sure translations are loaded
  // 200ms is not noticeable to the user, but it's enough to make sure translations are loaded
  setTimeout(() => {
    notify({
      title: i18n.global.t('auth.notAllowed.title'),
      message: i18n.global.t('auth.notAllowed.message'),
      type: UiNotificationType.WARNING,
      group: 'notify-top',
      timeout
    });
  }, 200);
};
